module.exports = __webpack_public_path__ + "static/WEDDING E&M-381-7a9a65f802c201006eeb41adb9e9350e.jpg";